import { render, staticRenderFns } from "./CreatorVideo.vue?vue&type=template&id=4edadf6b&"
import script from "./CreatorVideo.vue?vue&type=script&lang=js&"
export * from "./CreatorVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports